import PropTypes from 'prop-types';
import React from 'react';
import MaterialGrid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import { Field } from 'redux-form';
import { InputLabelOutlined } from 'common/components/fields/InputLabelOutlined';
import { InputSwitchLarge } from 'common/components/fields/InputSwitchLarge';
import { isLimitByAudienceApplicable, isLimitByAudienceFeatureEnabled } from './limitByAudience';
import { isStationGuestFeatureEnabled } from './audienceSection';

const AUDIENCE_INPUTS = [
  { name: 'limitFiliado', label: 'Limite para Filiados' },
  { name: 'limitAmigo', label: 'Limite para Amigos' },
  { name: 'limitDependente', label: 'Limite para Dependentes' },
];

const normalizeLimit = (value) => {
  if (value === '' || value === null || value === undefined) return null;
  const n = parseInt(value, 10);
  if (Number.isNaN(n) || n < 0) return null;
  return n;
};

export const LimitByAudienceField = ({ auth, formValues, isDisabled, typeId }) => {
  if (!isStationGuestFeatureEnabled(auth)) return null;
  if (!isLimitByAudienceFeatureEnabled(auth)) return null;
  if (!isLimitByAudienceApplicable(formValues, typeId)) return null;

  const effectiveDisabled = !!(
    isDisabled &&
    formValues?.end &&
    new Date() > new Date(formValues.end)
  );

  const enabled = !!formValues?.usesLimitByAudience;

  return (
    <MaterialGrid item xs={12} style={{ marginTop: 16 }}>
      <Field
        component={InputSwitchLarge}
        name="usesLimitByAudience"
        label="Usar limites diferentes por audiência"
        firstState="Ativo — cada audiência tem seu próprio limite"
        secondState="Inativo — usa o limite geral acima"
        disabled={effectiveDisabled}
      />
      {enabled ? (
        <>
          <Typography variant="caption" style={{ display: 'block', marginTop: 8, color: '#666' }}>
            Filiado em branco usa o limite geral. Amigo e Dependente em branco ficam bloqueados —
            defina um valor para liberá-los. Use 0 para bloquear.
          </Typography>
          {AUDIENCE_INPUTS.map((opt) => (
            <MaterialGrid key={opt.name} item xs={12} style={{ marginTop: 8 }}>
              <Field
                component={InputLabelOutlined}
                name={opt.name}
                label={opt.label}
                type="number"
                disabled={effectiveDisabled}
                margin="normal"
                normalize={normalizeLimit}
                inputProps={{ min: 0 }}
              />
            </MaterialGrid>
          ))}
        </>
      ) : null}
    </MaterialGrid>
  );
};

LimitByAudienceField.propTypes = {
  auth: PropTypes.object,
  formValues: PropTypes.object,
  isDisabled: PropTypes.bool,
  typeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
